let appConfig = {
  session: {
    retrySeconds: 2,
    retryErrors: ["RequestErrorConnection"],
  },
  loadingDelay: 1000,
  inputDebounce: 700,
  localKeyCacheSize: 1000,
  toastTTL: 5000,
  toastPause: 300,
  apiRoot: "/api",
  hubRoot: "/hub",
  imageRoot: "/Images",
  imageAdminRoot: "/api/Sitemap/Images",
  corsRequired: false,
  loginUrl: "/Login",
  logoutUrl: "/Logout",
  changePasswordUrl: "/ChangePassword",
  sessionPendingUrl: "/Pending",
  sessionInactiveUrl: "/Inactive",
  supportedBrowsersUrl: "/supported-browsers",
  iconTableUrl: "https://materialdesignicons.com/",
  defaultGlobalSettings: {
    shortcuts: {
      inlineLocalization: { modifier: "Ctrl", key: "l" },
      quickSubmit: { modifier: "Ctrl", key: "Enter" },
      gridScan: { modifier: "Alt", key: "s" },
    },
    indefiniteDatetime: "2999-01-01T00:00:00Z",
  },
  themeGuttersVertical: 1,
  themeGuttersHorizontal: 1.5,
  supportedLocales: ["de", "en"],
  defaultLocale: "de",
};

//const DEV_HOST = "";
//const DEV_HOST = "https://web.feature-1.dev.peaksecurity.de";
//const DEV_HOST = "https://localhost:5001";
const DEV_HOST = "https://web.plfgr.peaksecurity.de";
//const DEV_HOST = "https://web.ontras.peaksecurity.de";
//const DEV_HOST = "https://web.nabaltec.peaksecurity.de/";

async function setupDevConfig(config) {
  return {
    ...config,
    corsRequired: true,
    apiRoot: DEV_HOST + "/api",
    hubRoot: DEV_HOST + "/hub",
    imageRoot: DEV_HOST + "/Images",
    imageAdminRoot: DEV_HOST + "/api/Sitemap/Images",
    loginUrl: DEV_HOST + "/Login",
    logoutUrl: DEV_HOST + "/Logout",
    changePasswordUrl: DEV_HOST + "/ChangePassword",
    sessionPendingUrl: DEV_HOST + "/Pending",
    sessionInactiveUrl: DEV_HOST + "/Inactive",
    inactivityTimeoutOverride: 0,
    defaultGlobalSettings: {
      ...appConfig.defaultGlobalSettings,
      shortcuts: {
        ...appConfig.defaultGlobalSettings.shortcuts,
        gridScan: { modifier: "Ctrl", key: "s" },
      },
    },
    // localizationStringsOverride: await import("./fixtures/LocalizationOverride")
    //   .strings
    //notificationsOverride: await import("./fixtures/NotificationsOverride")
    //formOverride: await import("./fixtures/FormOverride"),
    //sitemapOverride: await import("./fixtures/SitemapOverride"),
    //sessionOverride: await import("./fixtures/SessionOverride"),
  };
}

if (process.env.NODE_ENV === "development")
  appConfig = await setupDevConfig(appConfig);

export default Object.freeze(appConfig);
